import _ from 'lodash';

export function isDescriptionHtmlBlank(html) {
  // Strip off p and br tags, clean blankspace, and check for empty
  return _.flow([(str) => _.replace(str, /<\/?p>/g, ''), (str) => _.replace(str, /<\/?br>/g, ''), _.trim, _.isEmpty])(
    html
  );
}

export function getDescriptionHtml(product) {
  let returnValue = '';

  if (product) {
    const description = _.get(product, 'Description', '') || '';
    const descriptionHtml = _.get(product, 'descriptionHtml', '') || '';

    const blankDescriptionHtml = isDescriptionHtmlBlank(descriptionHtml);

    if (blankDescriptionHtml) {
      returnValue = _.join(
        _.map(description.split('\n'), (line) => `<p>${_.isEmpty(line) ? ' ' : line}</p>`),
        ''
      );
    } else {
      returnValue = descriptionHtml;
    }
  }

  return returnValue;
}

// Expects to only work in the browser, where DOMParser is available.
export function getSimpleDescription(product, Parser) {
  if (!Parser) {
    console.log('DOMParser not available in this context. Is this a browser?');
    return '';
  }

  const productDescription = getDescriptionHtml(product);
  const parserInst = new Parser();
  return parserInst.parseFromString(productDescription, 'text/html').documentElement.textContent;
}

export default {
  getSimpleDescription,
  getDescriptionHtml,
  isDescriptionHtmlBlank,
};
